module.exports = __webpack_public_path__ + "img/strategy-main-banner1.656b485c.png";